import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray"; //@ts-check

import React from 'react';
import store from '../../store';
import ACTIONS from '../../store/actions';
import dataItemActions from '../../data/actions/item';
import itemSelector from '../../data/selectors/item';
import getPrettyError from '../../utils/getPrettyError';
/**
 * @type {import("./types").usePublicLinkFetchHook}
 */

var usePublicLinkFetch = function usePublicLinkFetch(publicId) {
  var _React$useState = React.useState({
    publicId: publicId,
    value: null,
    error: null,
    loading: true
  }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      output = _React$useState2[0],
      setOutput = _React$useState2[1];

  React.useEffect(function () {
    var dataIdentifier = {
      id: publicId,
      dataType: 'publicLink'
    };
    dataItemActions(dataIdentifier).fetch().then(function (response) {
      var error = response.type === ACTIONS.ITEM_GET_FAILED ? response.payload.text : undefined;

      if (error) {
        setOutput({
          publicId: publicId,
          value: null,
          error: error,
          loading: false
        });
      }
    }).catch(function (error) {
      setOutput({
        publicId: publicId,
        value: null,
        error: getPrettyError(error),
        loading: false
      });
    });
    return store.subscribe(function () {
      var nextState = store.getState();
      var nextData = itemSelector(nextState, dataIdentifier);

      if (nextData) {
        setOutput({
          publicId: publicId,
          error: null,
          loading: false,
          value: nextData
        });
      }
    });
  }, [publicId]);
  return output;
};

export default usePublicLinkFetch;